"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvinceIDCodeMapping = exports.CmhcProvinceIDSymbolMapping = exports.ProvinceIDSymbolMapping = exports.ProvinceSymbolIDMapping = exports.CanadaProvinceOfficeCode = exports.CanadaProvinceNameAbvr = exports.CmhcProvinceCode = exports.OfficeIDCode = exports.CanadaProvinceAbrv = exports.CanadaPostStandardProvinceSymbol = exports.StatisticsCanadaProvinceID = exports.Province = void 0;
var Province;
(function (Province) {
    Province[Province["NewFoundlandAndLabrador"] = 10] = "NewFoundlandAndLabrador";
    Province[Province["PrinceEdwardIsland"] = 11] = "PrinceEdwardIsland";
    Province[Province["NovaScotia"] = 12] = "NovaScotia";
    Province[Province["NewBrunswick"] = 13] = "NewBrunswick";
    Province[Province["Quebec"] = 24] = "Quebec";
    Province[Province["Ontario"] = 35] = "Ontario";
    Province[Province["Manitoba"] = 46] = "Manitoba";
    Province[Province["Saskatchewan"] = 47] = "Saskatchewan";
    Province[Province["Alberta"] = 48] = "Alberta";
    Province[Province["BritishColumbia"] = 59] = "BritishColumbia";
    Province[Province["Yukon"] = 60] = "Yukon";
    Province[Province["NorthwestTerritories"] = 61] = "NorthwestTerritories";
    Province[Province["Nunavut"] = 62] = "Nunavut";
})(Province = exports.Province || (exports.Province = {}));
var StatisticsCanadaProvinceID;
(function (StatisticsCanadaProvinceID) {
    StatisticsCanadaProvinceID["NewfoundlandAndLabrador"] = "10";
    StatisticsCanadaProvinceID["PrinceEdwardIsland"] = "11";
    StatisticsCanadaProvinceID["NovaScotia"] = "12";
    StatisticsCanadaProvinceID["NewBrunswick"] = "13";
    StatisticsCanadaProvinceID["Quebec"] = "24";
    StatisticsCanadaProvinceID["Ontario"] = "35";
    StatisticsCanadaProvinceID["Manitoba"] = "46";
    StatisticsCanadaProvinceID["Saskatchewan"] = "47";
    StatisticsCanadaProvinceID["Alberta"] = "48";
    StatisticsCanadaProvinceID["BritishColumbia"] = "59";
    StatisticsCanadaProvinceID["Yukon"] = "60";
    StatisticsCanadaProvinceID["NorthwestTerritories"] = "61";
    StatisticsCanadaProvinceID["Nunavut"] = "62";
})(StatisticsCanadaProvinceID = exports.StatisticsCanadaProvinceID || (exports.StatisticsCanadaProvinceID = {}));
var CanadaPostStandardProvinceSymbol;
(function (CanadaPostStandardProvinceSymbol) {
    CanadaPostStandardProvinceSymbol["Alberta"] = "AB";
    CanadaPostStandardProvinceSymbol["BritishColumbia"] = "BC";
    CanadaPostStandardProvinceSymbol["Manitoba"] = "MB";
    CanadaPostStandardProvinceSymbol["NewBrunswick"] = "NB";
    CanadaPostStandardProvinceSymbol["NewfoundlandAndLabrador"] = "NL";
    CanadaPostStandardProvinceSymbol["NovaScotia"] = "NS";
    CanadaPostStandardProvinceSymbol["NorthwestTerritories"] = "NT";
    CanadaPostStandardProvinceSymbol["Nunavut"] = "NU";
    CanadaPostStandardProvinceSymbol["Ontario"] = "ON";
    CanadaPostStandardProvinceSymbol["PrinceEdwardIsland"] = "PE";
    CanadaPostStandardProvinceSymbol["Quebec"] = "QC";
    CanadaPostStandardProvinceSymbol["Saskatchewan"] = "SK";
    CanadaPostStandardProvinceSymbol["Yukon"] = "YT";
})(CanadaPostStandardProvinceSymbol = exports.CanadaPostStandardProvinceSymbol || (exports.CanadaPostStandardProvinceSymbol = {}));
var CanadaProvinceAbrv;
(function (CanadaProvinceAbrv) {
    CanadaProvinceAbrv["Alberta"] = "ALTA";
    CanadaProvinceAbrv["BritishColumbia"] = "BC";
    CanadaProvinceAbrv["Manitoba"] = "MAN";
    CanadaProvinceAbrv["NewBrunswick"] = "NB";
    CanadaProvinceAbrv["NewfoundlandAndLabrador"] = "NL";
    CanadaProvinceAbrv["NovaScotia"] = "NS";
    CanadaProvinceAbrv["NorthwestTerritories"] = "NWT";
    CanadaProvinceAbrv["Nunavut"] = "NU";
    CanadaProvinceAbrv["Ontario"] = "ONT";
    CanadaProvinceAbrv["PrinceEdwardIsland"] = "PEI";
    CanadaProvinceAbrv["Quebec"] = "QUE";
    CanadaProvinceAbrv["Saskatchewan"] = "SASK";
    CanadaProvinceAbrv["Yukon"] = "YKN";
})(CanadaProvinceAbrv = exports.CanadaProvinceAbrv || (exports.CanadaProvinceAbrv = {}));
var OfficeIDCode;
(function (OfficeIDCode) {
    OfficeIDCode["Alberta"] = "014";
    OfficeIDCode["BritishColumbia"] = "016";
    OfficeIDCode["Manitoba"] = "012";
    OfficeIDCode["NewBrunswick"] = "019";
    OfficeIDCode["NewfoundlandAndLabrador"] = "001";
    OfficeIDCode["NovaScotia"] = "002";
    OfficeIDCode["NorthwestTerritories"] = "023";
    OfficeIDCode["Nunavut"] = "089";
    OfficeIDCode["Ontario"] = "006";
    OfficeIDCode["PrinceEdwardIsland"] = "076";
    OfficeIDCode["Quebec"] = "039";
    OfficeIDCode["Saskatchewan"] = "052";
    OfficeIDCode["Yukon"] = "029";
})(OfficeIDCode = exports.OfficeIDCode || (exports.OfficeIDCode = {}));
var CmhcProvinceCode;
(function (CmhcProvinceCode) {
    CmhcProvinceCode["Alberta"] = "08";
    CmhcProvinceCode["BritishColumbia"] = "09";
    CmhcProvinceCode["Manitoba"] = "06";
    CmhcProvinceCode["NewBrunswick"] = "03";
    CmhcProvinceCode["NewfoundlandAndLabrador"] = "00";
    CmhcProvinceCode["NovaScotia"] = "02";
    CmhcProvinceCode["NorthwestTerritories"] = "12";
    CmhcProvinceCode["Nunavut"] = "13";
    CmhcProvinceCode["Ontario"] = "05";
    CmhcProvinceCode["PrinceEdwardIsland"] = "01";
    CmhcProvinceCode["Quebec"] = "04";
    CmhcProvinceCode["Saskatchewan"] = "07";
    CmhcProvinceCode["Yukon"] = "11";
})(CmhcProvinceCode = exports.CmhcProvinceCode || (exports.CmhcProvinceCode = {}));
exports.CanadaProvinceNameAbvr = (_a = {},
    _a[StatisticsCanadaProvinceID.Alberta] = CanadaProvinceAbrv.Alberta,
    _a[StatisticsCanadaProvinceID.BritishColumbia] = CanadaProvinceAbrv.BritishColumbia,
    _a[StatisticsCanadaProvinceID.Manitoba] = CanadaProvinceAbrv.Manitoba,
    _a[StatisticsCanadaProvinceID.NewBrunswick] = CanadaProvinceAbrv.NewBrunswick,
    _a[StatisticsCanadaProvinceID.NewfoundlandAndLabrador] = CanadaProvinceAbrv.NewfoundlandAndLabrador,
    _a[StatisticsCanadaProvinceID.NovaScotia] = CanadaProvinceAbrv.NovaScotia,
    _a[StatisticsCanadaProvinceID.NorthwestTerritories] = CanadaProvinceAbrv.NorthwestTerritories,
    _a[StatisticsCanadaProvinceID.Nunavut] = CanadaProvinceAbrv.Nunavut,
    _a[StatisticsCanadaProvinceID.Ontario] = CanadaProvinceAbrv.Ontario,
    _a[StatisticsCanadaProvinceID.PrinceEdwardIsland] = CanadaProvinceAbrv.PrinceEdwardIsland,
    _a[StatisticsCanadaProvinceID.Quebec] = CanadaProvinceAbrv.Quebec,
    _a[StatisticsCanadaProvinceID.Saskatchewan] = CanadaProvinceAbrv.Saskatchewan,
    _a[StatisticsCanadaProvinceID.Yukon] = CanadaProvinceAbrv.Yukon,
    _a);
exports.CanadaProvinceOfficeCode = (_b = {},
    _b[StatisticsCanadaProvinceID.Alberta] = OfficeIDCode.Alberta,
    _b[StatisticsCanadaProvinceID.BritishColumbia] = OfficeIDCode.BritishColumbia,
    _b[StatisticsCanadaProvinceID.Manitoba] = OfficeIDCode.Manitoba,
    _b[StatisticsCanadaProvinceID.NewBrunswick] = OfficeIDCode.NewBrunswick,
    _b[StatisticsCanadaProvinceID.NewfoundlandAndLabrador] = OfficeIDCode.NewfoundlandAndLabrador,
    _b[StatisticsCanadaProvinceID.NovaScotia] = OfficeIDCode.NovaScotia,
    _b[StatisticsCanadaProvinceID.NorthwestTerritories] = OfficeIDCode.NorthwestTerritories,
    _b[StatisticsCanadaProvinceID.Nunavut] = OfficeIDCode.Nunavut,
    _b[StatisticsCanadaProvinceID.Ontario] = OfficeIDCode.Ontario,
    _b[StatisticsCanadaProvinceID.PrinceEdwardIsland] = OfficeIDCode.PrinceEdwardIsland,
    _b[StatisticsCanadaProvinceID.Quebec] = OfficeIDCode.Quebec,
    _b[StatisticsCanadaProvinceID.Saskatchewan] = OfficeIDCode.Saskatchewan,
    _b[StatisticsCanadaProvinceID.Yukon] = OfficeIDCode.Yukon,
    _b);
// converts province symbol to province numerical ID
exports.ProvinceSymbolIDMapping = (_c = {},
    _c[CanadaPostStandardProvinceSymbol.Alberta] = StatisticsCanadaProvinceID.Alberta,
    _c[CanadaPostStandardProvinceSymbol.BritishColumbia] = StatisticsCanadaProvinceID.BritishColumbia,
    _c[CanadaPostStandardProvinceSymbol.Manitoba] = StatisticsCanadaProvinceID.Manitoba,
    _c[CanadaPostStandardProvinceSymbol.NewBrunswick] = StatisticsCanadaProvinceID.NewBrunswick,
    _c[CanadaPostStandardProvinceSymbol.NewfoundlandAndLabrador] = StatisticsCanadaProvinceID.NewfoundlandAndLabrador,
    _c[CanadaPostStandardProvinceSymbol.NovaScotia] = StatisticsCanadaProvinceID.NovaScotia,
    _c[CanadaPostStandardProvinceSymbol.NorthwestTerritories] = StatisticsCanadaProvinceID.NorthwestTerritories,
    _c[CanadaPostStandardProvinceSymbol.Nunavut] = StatisticsCanadaProvinceID.Nunavut,
    _c[CanadaPostStandardProvinceSymbol.Ontario] = StatisticsCanadaProvinceID.Ontario,
    _c[CanadaPostStandardProvinceSymbol.PrinceEdwardIsland] = StatisticsCanadaProvinceID.PrinceEdwardIsland,
    _c[CanadaPostStandardProvinceSymbol.Quebec] = StatisticsCanadaProvinceID.Quebec,
    _c[CanadaPostStandardProvinceSymbol.Saskatchewan] = StatisticsCanadaProvinceID.Saskatchewan,
    _c[CanadaPostStandardProvinceSymbol.Yukon] = StatisticsCanadaProvinceID.Yukon,
    _c);
// converts province numerical ID to province symbol
exports.ProvinceIDSymbolMapping = (_d = {},
    _d[StatisticsCanadaProvinceID.Alberta] = CanadaPostStandardProvinceSymbol.Alberta,
    _d[StatisticsCanadaProvinceID.BritishColumbia] = CanadaPostStandardProvinceSymbol.BritishColumbia,
    _d[StatisticsCanadaProvinceID.Manitoba] = CanadaPostStandardProvinceSymbol.Manitoba,
    _d[StatisticsCanadaProvinceID.NewBrunswick] = CanadaPostStandardProvinceSymbol.NewBrunswick,
    _d[StatisticsCanadaProvinceID.NewfoundlandAndLabrador] = CanadaPostStandardProvinceSymbol.NewfoundlandAndLabrador,
    _d[StatisticsCanadaProvinceID.NovaScotia] = CanadaPostStandardProvinceSymbol.NovaScotia,
    _d[StatisticsCanadaProvinceID.NorthwestTerritories] = CanadaPostStandardProvinceSymbol.NorthwestTerritories,
    _d[StatisticsCanadaProvinceID.Nunavut] = CanadaPostStandardProvinceSymbol.Nunavut,
    _d[StatisticsCanadaProvinceID.Ontario] = CanadaPostStandardProvinceSymbol.Ontario,
    _d[StatisticsCanadaProvinceID.PrinceEdwardIsland] = CanadaPostStandardProvinceSymbol.PrinceEdwardIsland,
    _d[StatisticsCanadaProvinceID.Quebec] = CanadaPostStandardProvinceSymbol.Quebec,
    _d[StatisticsCanadaProvinceID.Saskatchewan] = CanadaPostStandardProvinceSymbol.Saskatchewan,
    _d[StatisticsCanadaProvinceID.Yukon] = CanadaPostStandardProvinceSymbol.Yukon,
    _d);
// converts cmhcprovince numerical ID to province code
exports.CmhcProvinceIDSymbolMapping = (_e = {},
    _e[CmhcProvinceCode.Alberta] = CanadaPostStandardProvinceSymbol.Alberta,
    _e[CmhcProvinceCode.BritishColumbia] = CanadaPostStandardProvinceSymbol.BritishColumbia,
    _e[CmhcProvinceCode.Manitoba] = CanadaPostStandardProvinceSymbol.Manitoba,
    _e[CmhcProvinceCode.NewBrunswick] = CanadaPostStandardProvinceSymbol.NewBrunswick,
    _e[CmhcProvinceCode.NewfoundlandAndLabrador] = CanadaPostStandardProvinceSymbol.NewfoundlandAndLabrador,
    _e[CmhcProvinceCode.NovaScotia] = CanadaPostStandardProvinceSymbol.NovaScotia,
    _e[CmhcProvinceCode.NorthwestTerritories] = CanadaPostStandardProvinceSymbol.NorthwestTerritories,
    _e[CmhcProvinceCode.Nunavut] = CanadaPostStandardProvinceSymbol.Nunavut,
    _e[CmhcProvinceCode.Ontario] = CanadaPostStandardProvinceSymbol.Ontario,
    _e[CmhcProvinceCode.PrinceEdwardIsland] = CanadaPostStandardProvinceSymbol.PrinceEdwardIsland,
    _e[CmhcProvinceCode.Quebec] = CanadaPostStandardProvinceSymbol.Quebec,
    _e[CmhcProvinceCode.Saskatchewan] = CanadaPostStandardProvinceSymbol.Saskatchewan,
    _e[CmhcProvinceCode.Yukon] = CanadaPostStandardProvinceSymbol.Yukon,
    _e);
// converts province numerical ID to province code
exports.ProvinceIDCodeMapping = (_f = {},
    _f[StatisticsCanadaProvinceID.Alberta] = CmhcProvinceCode.Alberta,
    _f[StatisticsCanadaProvinceID.BritishColumbia] = CmhcProvinceCode.BritishColumbia,
    _f[StatisticsCanadaProvinceID.Manitoba] = CmhcProvinceCode.Manitoba,
    _f[StatisticsCanadaProvinceID.NewBrunswick] = CmhcProvinceCode.NewBrunswick,
    _f[StatisticsCanadaProvinceID.NewfoundlandAndLabrador] = CmhcProvinceCode.NewfoundlandAndLabrador,
    _f[StatisticsCanadaProvinceID.NovaScotia] = CmhcProvinceCode.NovaScotia,
    _f[StatisticsCanadaProvinceID.NorthwestTerritories] = CmhcProvinceCode.NorthwestTerritories,
    _f[StatisticsCanadaProvinceID.Nunavut] = CmhcProvinceCode.Nunavut,
    _f[StatisticsCanadaProvinceID.Ontario] = CmhcProvinceCode.Ontario,
    _f[StatisticsCanadaProvinceID.PrinceEdwardIsland] = CmhcProvinceCode.PrinceEdwardIsland,
    _f[StatisticsCanadaProvinceID.Quebec] = CmhcProvinceCode.Quebec,
    _f[StatisticsCanadaProvinceID.Saskatchewan] = CmhcProvinceCode.Saskatchewan,
    _f[StatisticsCanadaProvinceID.Yukon] = CmhcProvinceCode.Yukon,
    _f);
